export default "__VITE_ASSET__CxVy3QV2__"